import React, { memo } from 'react';
import { Box } from '@mui/material';
import EnergyLabel from './EnergyLabel';
import EnergyFlow from './EnergyFlow';

import { ReactComponent as GridIcon } from "../../../../assets/images/overview/grid.svg";
import { ReactComponent as SolarIcon } from "../../../../assets/images/overview/solar.svg";
import { ReactComponent as LoadIcon } from "../../../../assets/images/overview/load.svg";
import { ReactComponent as BatteryIcon } from "../../../../assets/images/overview/battery.svg";

const formatKw = (value) => (value == null ? null : `${Number(value.toFixed(1))} kW`);

const AnimationCard = ({
  gridPower,
  batterySOC,
  batteryStatus,
  batteryPower,
  pcsPower,
  loadPower,
  solarPower,
}) => {
  const batterySubText = [
    batterySOC != null ? `${batterySOC}%` : null,
    batteryStatus,
  ].filter(Boolean).join(" · ");

  return (
    <Box sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: { xs: 1, sm: 2 },
      height: "100%",
    }}>
      <EnergyLabel
        title="Utility"
        icon={<GridIcon />}
        mainText={formatKw(gridPower)}
      />

      <Box sx={{
        flex: 1,
        maxWidth: 560,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
      }}>
        <EnergyLabel
          title="Solar"
          icon={<SolarIcon style={{ color: 'black' }} />}
          // Solar is negative when exporting, show generation as a positive number
          mainText={formatKw(solarPower == null ? null : Math.abs(solarPower))}
        />
        <EnergyFlow
          className='AnimationCard'
          gridPower={gridPower}
          solarPower={solarPower}
          // Battery direction follows the PCS (AC side), falling back to the battery meter
          batteryPower={pcsPower ?? batteryPower}
          loadPower={loadPower}
          style={{ width: "100%", display: "block" }}
        />
        <EnergyLabel
          title="Battery"
          icon={<BatteryIcon />}
          subText={batterySubText}
          mainText={formatKw(batteryPower)}
        />
      </Box>

      <EnergyLabel
        title="Load"
        icon={<LoadIcon />}
        mainText={formatKw(loadPower)}
      />
    </Box>
  )
}

// Memoised so polls that don't change the power values don't touch the animated SVG
export default memo(AnimationCard);
